import { CERTIFIED_ORGANIZER_PERKS } from "../organizerInvitation/certifiedOrganizerPerks";

// Badges de certification KARANGO (ADR-019, ADR-020) : tout ce qui change d'un badge
// a l'autre (logo, libelles, textes d'invitation et de felicitations) est ici.
export const CERTIFICATION_KINDS = Object.freeze({
  ORGANIZER: {
    kind: "ORGANIZER",
    userField: "isApprovedOrganizer",
    // Onglet admin « Certifications » : filtre de la liste et date d'attribution.
    adminFilter: "approved-organizers",
    certifiedAtField: "approvedOrganizerAt",
    logo: "/organisateur-certifie.svg",
    label: "Organisateur certifié",
    shortLabel: "Orga certifié",
    explanation: "Badge attribué par KARANGO à des organisateurs que nous connaissons personnellement. Nous avons partagé plusieurs sorties avec eux et les recommandons pour leur sérieux, leur bienveillance et la qualité de leurs événements.",
    invitation: {
      title: "Deviens Organisateur certifié",
      lead: "KARANGO t'invite à rejoindre ses organisateurs certifiés : des personnes que nous connaissons et recommandons pour leur sérieux, leur bienveillance et la qualité de leurs sorties.",
      perks: CERTIFIED_ORGANIZER_PERKS,
    },
    celebration: {
      groupLabel: "Organisateurs certifiés",
      text: "Ton badge brille sur ton profil et tes sorties, et tu peux accueillir jusqu'à 30 participants.",
      cheer: "Alors, c'est quoi ta prochaine sortie ? Rando, apéro, soirée jeux, expo… Lance-toi : toute la communauté KARANGO est derrière toi ! 💜",
      cta: "C'est parti, je crée ma sortie !",
    },
  },
  DRIVER: {
    kind: "DRIVER",
    userField: "isApprovedDriver",
    // Onglet admin « Certifications » : filtre de la liste et date d'attribution.
    adminFilter: "approved-drivers",
    certifiedAtField: "approvedDriverAt",
    logo: "/conducteur-certifie.svg",
    label: "Conducteur certifié",
    shortLabel: "Conducteur certifié",
    explanation: "Badge attribué par KARANGO à des conducteurs que nous connaissons personnellement et que nous recommandons pour leur sérieux et leur fiabilité.",
    invitation: {
      title: "Deviens Conducteur certifié",
      lead: "KARANGO t'invite à rejoindre ses conducteurs certifiés : des personnes que nous connaissons et recommandons pour leur sérieux et leur fiabilité au volant.",
      perks: [
        {
          id: "driver-badge",
          icon: "🚗",
          title: "Le badge « Conducteur certifié »",
          description: "Il apparaît sur ton profil, sur tes offres de covoiturage et sur la carte des trajets. Un clic explique qu'il est attribué par KARANGO.",
        },
        {
          id: "driver-trust",
          icon: "🤝",
          title: "Des passagers en confiance",
          description: "Les membres qui cherchent une voiture voient tout de suite que KARANGO te recommande.",
        },
      ],
    },
    celebration: {
      groupLabel: "Conducteurs certifiés",
      text: "Ton badge brille sur ton profil, sur tes offres de covoiturage et sur la carte des trajets.",
      cheer: "Propose ton prochain trajet : des passagers comptent sur toi, et toute la communauté KARANGO est derrière toi ! 🚗",
      cta: "C'est parti, je propose un trajet !",
    },
  },
  MEMBER: {
    kind: "MEMBER",
    userField: "isCertifiedMember",
    // Onglet admin « Certifications » : filtre de la liste et date d'attribution.
    adminFilter: "certified-members",
    certifiedAtField: "certifiedMemberAt",
    logo: "/utilisateur-certifie.svg",
    label: "Utilisateur certifié",
    shortLabel: "Certifié",
    explanation: "Membre recommandé par la communauté KARANGO : une personne déjà certifiée le connaît et se porte garante de lui.",
    invitation: {
      title: "Deviens Utilisateur certifié",
      lead: "KARANGO t'invite à rejoindre ses utilisateurs certifiés : des membres connus et recommandés par la communauté.",
      perks: [
        {
          id: "member-badge",
          icon: "🏅",
          title: "Le badge « Utilisateur certifié »",
          description: "Il apparaît sur ton profil, avec la personne qui t'a certifié.",
        },
        {
          id: "member-sponsor",
          icon: "🤝",
          title: "Certifier à ton tour",
          description: "Tu peux proposer la certification à 5 personnes de confiance, depuis leur profil.",
        },
      ],
    },
    celebration: {
      groupLabel: "Utilisateurs certifiés",
      text: "Ton badge brille sur ton profil, avec la personne qui t'a certifié.",
      cheer: "À ton tour : tu peux certifier jusqu'à 5 personnes de confiance depuis leur profil. La communauté KARANGO grandit grâce à toi ! 🤝",
      cta: "Découvrir KARANGO",
    },
  },
});

export function getCertificationKind(kind) {
  return CERTIFICATION_KINDS[String(kind || "").toUpperCase()] || CERTIFICATION_KINDS.ORGANIZER;
}
